import type {
  AccessLevel,
  TeamEffectiveRightsByProductType,
} from '@eye-able/types';

type GovernanceAccessUser = {
  isAdmin?: boolean;
  isSalesAdmin?: boolean;
};

/**
 * Governance rights are granted per domain (the license id is the audit entry
 * id). Without a `domainId`, the highest level across all Governance domains
 * decides area access. Per-domain decisions pass the concrete domain id.
 */
export function getGovernanceDomainAccessLevel({
  domainId,
  effectiveRights,
  user,
}: {
  domainId?: number;
  effectiveRights: TeamEffectiveRightsByProductType | null | undefined;
  user: GovernanceAccessUser | null | undefined;
}): AccessLevel | null {
  if (user?.isAdmin || user?.isSalesAdmin) {
    return 'editor';
  }

  if (!effectiveRights) return null;

  const matchingRights =
    domainId == null
      ? effectiveRights.governance
      : effectiveRights.governance.filter(
          ({ licenseId }) => licenseId === domainId,
        );

  return matchingRights.some(({ accessLevel }) => accessLevel === 'editor')
    ? 'editor'
    : matchingRights.some(({ accessLevel }) => accessLevel === 'viewer')
      ? 'viewer'
      : null;
}
